import ScaleLine from '../control/ScaleLine.js';
import getDPI from '../utils/getDPI.js';

function getScaleFromRes(mymap) {
    const res1 = new ScaleLine();

    var dpi = getDPI();
    res1.setDpi(dpi);

    var scaleResolution = res1.getScaleForResolutionGro(mymap);
    return scaleResolution;
}

export default getScaleFromRes;
